module.exports = __webpack_public_path__ + "static/media/smile-beam.e743cd4e.svg";